import { createFileRoute } from '@tanstack/react-router';
import { RoleGuard } from '@/lib/auth/RoleGuard';
import { AuthenticatedShell } from '@/features/app/AuthenticatedShell';
import { ContactTemplateList } from '@/features/admin/outreach/ContactTemplateList';
import { AttributionSettings } from '@/features/admin/outreach/AttributionSettings';

export const Route = createFileRoute('/admin/outreach')({ component: OutreachAdminPage });

function OutreachAdminPage() {
  return (
    <RoleGuard allow={['PlatformAdmin']}>
      <AuthenticatedShell activeNavId="admin-outreach">
        <div className="mx-auto max-w-3xl space-y-6 p-6">
          <h1 className="text-xl font-semibold text-slate-900">Outreach Templates</h1>
          <ContactTemplateList />
          <AttributionSettings />
        </div>
      </AuthenticatedShell>
    </RoleGuard>
  );
}
